import { handleMessages, load } from './util';

$(document).on('click', '[data-comparison-list]', (event) => {
  const $target = $(event.currentTarget);
  const active = $target.hasClass('active');
  $target.toggleClass('active');
  $.ajax({
    url: $target.attr(active ? 'data-remove-comparison-list' : 'data-add-comparison-list'),
    method: 'post',
  }).then(handleMessages).then((json) => {
    if (json.limit_exceeded) {
      $target.toggleClass('active');
    } else {
      $('[data-comparison-list-count]').text(json.count)[json.count ? 'removeClass' : 'addClass']('hide');
      $('[data-comparison-list-preview]')[json.count ? 'removeClass' : 'addClass']('hide');
      $('[data-comparison-list-preview-content]').html('');
    }
    if (window.location.href.indexOf('item-comparison') > -1) {
      window.location.href = json.redirect;
    }
  });
});

$(document).on('show.zf.dropdown', '#comparison-list-menu', function () {
  if (!$('[data-comparison-list-preview-content]').html().trim()) {
    load(
      $(this).find('[data-comparison-list-preview-widget]'),
      $.ajax({
        url: $(this).attr('data-comparison-list-preview'),
        method: 'GET',
      }).then((html) => {
        $('[data-comparison-list-preview-content]').html(html);
      }),
    );
  }
});

$(document).on('click', '.comparison-group-delete', (event) => {
  event.stopPropagation();
  event.preventDefault();
  const $this = $(event.currentTarget);
  const $comparisonGroupIds = JSON.parse($this.attr('data-comparison-group-ids'));
  const $preview = $this.closest('[data-comparison-list-preview]');
  load(
    $preview.find('[data-comparison-list-preview-widget]'),
    $.ajax({
      url: $this.attr('data-remove-comparison-group'),
      method: 'post',
    }).then((json) => {
      $('[data-comparison-list-count]').text(json.count)[json.count ? 'removeClass' : 'addClass']('hide');
      $('[data-comparison-list-preview]')[json.count ? 'removeClass' : 'addClass']('hide');
      $('[data-comparison-list-preview-content]').html('');
      return $.ajax({
        url: $('#comparison-list-menu').attr('data-comparison-list-preview'),
        method: 'GET',
      }).then((html) => {
        $comparisonGroupIds.forEach((itemId) => {
          $(`[data-comparison-list="${itemId}"`).removeClass('active');
        });
        $('[data-comparison-list-preview-content]').html(html);
        if ($this.data('reload')) {
          window.location.reload();
        }
      });
    }),
  );
});

// Merge comparison table rows
const allEqual = arr => arr.every(v => v === arr[0]);
$(document).ready(() => {
  const $rows = $('[data-comparison-row]');
  $rows.each((i, row) => {
    let prevCell = [];
    let $cells = $(row).find('[data-comparison-value]');
    $cells.each((j, cell) => {
      const $cell = $(cell);
      if (prevCell.length && prevCell.text().trim() === $cell.text().trim()) {
        $cell.remove();
        const currentSpan = prevCell.attr('colSpan');
        prevCell.attr('colSpan', `${parseInt(currentSpan, 10) + 1}`);
      } else {
        prevCell = $cell;
      }
    });
    // Remove empty rows
    $cells = $(row).find('[data-comparison-value]');
    if ($cells.length === 1 && ['', '-'].includes($($cells[0]).text().trim())) {
      row.remove();
    }
  });
});

$(document).ready(() => {
  const showOnlyDifferentFeatures = localStorage.getItem('showOnlyDifferentFeatures');
  if (showOnlyDifferentFeatures) {
    $('#comparisonFilterShowDifferent').click();
  }
});

$(document).on('click', '[data-exit-comparison]', () => {
  localStorage.removeItem('showOnlyDifferentFeatures');
});

$('#comparisonFilterShowDifferent').on('input', (event) => {
  event.preventDefault();
  const $showDifferent = $(event.target).is(':checked');
  $('[data-comparison-row]').each((i, row) => {
    const rowValues = [];
    $(row).show();
    if ($showDifferent) {
      $(row).children('td').each((j, value) => {
        rowValues.push($(value).text().trim());
      });
      if (!rowValues.length || allEqual(rowValues)) {
        $(row).hide();
      }
    }
  });
  if ($showDifferent) {
    localStorage.setItem('showOnlyDifferentFeatures', $showDifferent);
  } else {
    localStorage.removeItem('showOnlyDifferentFeatures');
  }
});

$('#comparison-list-select').on('change', (event) => {
  localStorage.removeItem('showOnlyDifferentFeatures');
  window.location.href = $(event.target).val();
});
